var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _defs, _path13, _path14, _path15, _path16, _path17, _g2, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    className: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrowr",
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 1L11 11L1 1",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: 360,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8647 6.20509H4.37793M4.37793 6.20509C5.21367 6.20509 5.89116 6.92257 5.89116 7.80763C5.89116 8.69269 5.21367 9.41018 4.37793 9.41018H2M4.37793 6.20509C5.21367 6.20509 5.89116 5.48761 5.89116 4.60254C5.89116 3.71748 5.21367 3 4.37793 3H2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5646 12.1582C17.5646 15.1927 14.0804 17.6526 9.78232 17.6526C5.48427 17.6526 2 15.1927 2 12.1582",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5106 3H10.6459C9.21314 3 8.05176 4.22998 8.05176 5.74722V7.5787M8.05176 7.5787C8.05176 8.59022 8.82601 9.41018 9.78116 9.41018H10.2135C11.1687 9.41018 11.9429 8.59022 11.9429 7.5787V7.12083C11.9429 6.10933 11.1687 5.28935 10.2135 5.28935H9.78116C8.82601 5.28935 8.05176 6.10933 8.05176 7.12083V7.5787Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1104 6.20509V4.83148C14.1104 3.81998 14.8846 3 15.8398 3H16.2721C17.2273 3 18.0015 3.81998 18.0015 4.83148V6.20509V7.5787C18.0015 8.59022 17.2273 9.41018 16.2721 9.41018H15.8398C14.8846 9.41018 14.1104 8.59022 14.1104 7.5787V6.20509Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "car",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7959 13.5792C6.34818 13.5792 6.7959 13.1237 6.7959 12.5618C6.7959 11.9999 6.34818 11.5444 5.7959 11.5444C5.24362 11.5444 4.7959 11.9999 4.7959 12.5618C4.7959 13.1237 5.24362 13.5792 5.7959 13.5792Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1973 13.5792C14.7495 13.5792 15.1973 13.1237 15.1973 12.5618C15.1973 11.9999 14.7495 11.5444 14.1973 11.5444C13.645 11.5444 13.1973 11.9999 13.1973 12.5618C13.1973 13.1237 13.645 13.5792 14.1973 13.5792Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2 15.6153C2.53726 15.6153 2 15.0687 2 14.3944V10.6138C2 9.68866 2.51394 8.84295 3.32744 8.42953L3.60021 8.29089L4.5242 4.25825C4.69304 3.52136 5.33868 3 6.0824 3H13.9577C14.707 3 15.356 3.52902 15.5192 4.27299L16.4012 8.29089L16.6734 8.42929C17.4864 8.84291 18 9.68833 18 10.6132V14.3944C18 15.0687 17.4628 15.6153 16.8 15.6153H16.0012V16.0222C16.0012 16.9212 15.2843 17.65 14.4006 17.65C13.517 17.65 12.8 16.9212 12.8 16.0222V15.6153H7.2V16.0223C7.2 16.9213 6.48372 17.65 5.60012 17.65C4.71652 17.65 4.00021 16.9213 4.00021 16.0223V15.6153H3.2Z",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.50869H14L13.3392 6.48351C13.2579 6.11115 12.9332 5.84619 12.5583 5.84619H7.44172C7.06676 5.84619 6.74212 6.11115 6.6608 6.48351L6 9.50869Z",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "map",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 7.9165C16.625 13.4582 9.5 18.2082 9.5 18.2082C9.5 18.2082 2.375 13.4582 2.375 7.9165C2.375 6.02684 3.12567 4.21456 4.46186 2.87837C5.79806 1.54217 7.61033 0.791504 9.5 0.791504C11.3897 0.791504 13.2019 1.54217 14.5381 2.87837C15.8743 4.21456 16.625 6.02684 16.625 7.9165Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.2915C10.8117 10.2915 11.875 9.22818 11.875 7.9165C11.875 6.60483 10.8117 5.5415 9.5 5.5415C8.18832 5.5415 7.125 6.60483 7.125 7.9165C7.125 9.22818 8.18832 10.2915 9.5 10.2915Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "whastapp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0498 4.91006C18.133 3.98399 17.041 3.24973 15.8374 2.75011C14.6339 2.25049 13.3429 1.99552 12.0398 2.00006C6.5798 2.00006 2.1298 6.45006 2.1298 11.9101C2.1298 13.6601 2.5898 15.3601 3.4498 16.8601L2.0498 22.0001L7.2998 20.6201C8.7498 21.4101 10.3798 21.8301 12.0398 21.8301C17.4998 21.8301 21.9498 17.3801 21.9498 11.9201C21.9498 9.27006 20.9198 6.78006 19.0498 4.91006ZM12.0398 20.1501C10.5598 20.1501 9.1098 19.7501 7.8398 19.0001L7.5398 18.8201L4.4198 19.6401L5.2498 16.6001L5.0498 16.2901C4.22755 14.977 3.79094 13.4593 3.7898 11.9101C3.7898 7.37006 7.4898 3.67006 12.0298 3.67006C14.2298 3.67006 16.2998 4.53006 17.8498 6.09006C18.6173 6.85402 19.2255 7.76272 19.6392 8.76348C20.0529 9.76425 20.2638 10.8372 20.2598 11.9201C20.2798 16.4601 16.5798 20.1501 12.0398 20.1501ZM16.5598 13.9901C16.3098 13.8701 15.0898 13.2701 14.8698 13.1801C14.6398 13.1001 14.4798 13.0601 14.3098 13.3001C14.1398 13.5501 13.6698 14.1101 13.5298 14.2701C13.3898 14.4401 13.2398 14.4601 12.9898 14.3301C12.7398 14.2101 11.9398 13.9401 10.9998 13.1001C10.2598 12.4401 9.7698 11.6301 9.6198 11.3801C9.4798 11.1301 9.5998 11.0001 9.7298 10.8701C9.8398 10.7601 9.9798 10.5801 10.0998 10.4401C10.2198 10.3001 10.2698 10.1901 10.3498 10.0301C10.4298 9.86006 10.3898 9.72006 10.3298 9.60006C10.2698 9.48006 9.7698 8.26006 9.5698 7.76006C9.3698 7.28006 9.1598 7.34006 9.0098 7.33006H8.5298C8.3598 7.33006 8.0998 7.39006 7.8698 7.64006C7.6498 7.89006 7.0098 8.49006 7.0098 9.71006C7.0098 10.9301 7.8998 12.1101 8.0198 12.2701C8.1398 12.4401 9.7698 14.9401 12.2498 16.0101C12.8398 16.2701 13.2998 16.4201 13.6598 16.5301C14.2498 16.7201 14.7898 16.6901 15.2198 16.6301C15.6998 16.5601 16.6898 16.0301 16.8898 15.4501C17.0998 14.8701 17.0998 14.3801 17.0298 14.2701C16.9598 14.1601 16.8098 14.1101 16.5598 13.9901Z",
    fill: "#D69C4F"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "bed",
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1495_20515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 0H0V20H19V0Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1665 5C3.1665 4.30963 3.69817 3.75 4.354 3.75H14.6457C15.3015 3.75 15.8332 4.30963 15.8332 5V9.58333H3.1665V5Z",
    stroke: "#D69C4F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.375 14.5833V16.2499",
    stroke: "#D69C4F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.625 14.5833V16.2499",
    stroke: "#D69C4F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9165 7.5H5.5415C4.88565 7.5 4.354 8.05963 4.354 8.75V9.58333H9.104V8.75C9.104 8.05963 8.57236 7.5 7.9165 7.5Z",
    stroke: "#D69C4F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4585 7.5H11.0835C10.4276 7.5 9.896 8.05963 9.896 8.75V9.58333H14.646V8.75C14.646 8.05963 14.1144 7.5 13.4585 7.5Z",
    stroke: "#D69C4F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5835 10.8333C1.5835 10.1429 2.11516 9.58325 2.771 9.58325H16.2293C16.8852 9.58325 17.4168 10.1429 17.4168 10.8333V14.5833H1.5835V10.8333Z",
    stroke: "#D69C4F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1495_20515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 20,
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "clock",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4V8.5L11.5 10M16 8.5C16 12.6421 12.6421 16 8.5 16C4.35786 16 1 12.6421 1 8.5C1 4.35786 4.35786 1 8.5 1C12.6421 1 16 4.35786 16 8.5Z",
    stroke: "#D69C4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "restaurant",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3461 2.68361C12.274 2.16275 11.0701 1.87061 9.79805 1.87061C5.30793 1.87061 1.66797 5.51057 1.66797 10.0007C1.66797 14.4908 5.30793 18.1308 9.79805 18.1308C11.4499 18.1308 12.9868 17.6381 14.2696 16.7917",
    stroke: "#D69C4F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2374 10.0005C12.2374 8.65351 11.1454 7.56152 9.7984 7.56152C8.45136 7.56152 7.35938 8.65351 7.35938 10.0005C7.35938 11.3476 8.45136 12.4396 9.7984 12.4396C11.1454 12.4396 12.2374 11.3476 12.2374 10.0005Z",
    stroke: "#D69C4F",
    strokeWidth: 1.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3348 11.6267V5.12264V2.12714C18.3348 1.99356 18.2139 1.8926 18.0824 1.9165V1.9165C15.6392 2.36072 13.8633 4.48866 13.8633 6.97193V10.5313C13.8633 10.6999 13.9712 10.8497 14.1312 10.903L16.3023 11.6267",
    stroke: "#D69C4F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.301 11.6265L15.9277 17.5993C15.9097 17.8872 16.1383 18.1305 16.4268 18.1305H17.8336C18.1097 18.1305 18.3336 17.9067 18.3336 17.6305V13.7945V11.6265",
    stroke: "#D69C4F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "coffe",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_457_69492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 4H9.4C9.82435 4 10.2313 4.15804 10.5314 4.43934C10.8314 4.72064 11 5.10218 11 5.5C11 5.89782 10.8314 6.27936 10.5314 6.56066C10.2313 6.84196 9.82435 7 9.4 7H9",
    stroke: "#D69C4F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 4H9V8.5C9 9.03043 8.78929 9.53914 8.41421 9.91421C8.03914 10.2893 7.53043 10.5 7 10.5H3C2.46957 10.5 1.96086 10.2893 1.58579 9.91421C1.21071 9.53914 1 9.03043 1 8.5V4Z",
    stroke: "#D69C4F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 0.5V2",
    stroke: "#D69C4F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 0.5V2",
    stroke: "#D69C4F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 0.5V2",
    stroke: "#D69C4F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_457_69492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtons);
export default __webpack_public_path__ + "static/media/buttons.34f1e9e23cc2c3c800c3157fa7e61e36.svg";
export { ForwardRef as ReactComponent };